var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Info/Outlined") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ROAM-2421_Statement-Guide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ROAM-2421---V1.2-E-Statements_Statement-Guide---Mobile",
    transform: "translate(-157.000000, -811.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card-/-Template-/-Marketing-Banner-/-Mobile-/-Info",
    transform: "translate(24.000000, 782.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(136.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    stroke: "#52356E",
    strokeWidth: 5.30977879
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 28,
    cy: 28,
    r: 28
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(20.125000, 12.250000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    stroke: "#52356E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5.30977879
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,6.5625 C0,2.94 3.525375,0 7.875,0 C12.222,0 15.75,2.94 15.75,6.5625 C15.75,10.189375 12.222,13.125 7.875,13.125 L7.875,19.25",
    id: "Stroke-3216"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#52356E",
    cx: 7.875,
    cy: 28,
    r: 3.828125
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOutlined);
export default __webpack_public_path__ + "static/media/info-outlined.55610dcf.svg";
export { ForwardRef as ReactComponent };